import React from 'react';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import { Container } from "components/misc/Layouts.js";
import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial2.js";
import Footer from "components/footers/MiniCenteredFooter.js";

// Tailwind CSS is assumed to be available in the environment.

const TermsOfService = () => {
  return (
      <AnimationRevealPage>
    <Container>
      <Hero />
    <div className="container2">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg p-6 sm:p-10">
        <header className="mb-8 border-b pb-4">
          <h1 className="text-3xl font-extrabold text-indigo-700 mb-2">
            Belle IT Terms of Service
          </h1>
          <p className="text-sm text-gray-500">
            Last Updated: November 18, 2025
          </p>
          <p className="mt-4 text-gray-600">
            Welcome to Belle IT. By accessing or using our services, you agree to be bound by these Terms.
          </p>
        </header>

        <section className="space-y-6 text-gray-700">
          {/* Section 1: General Terms */}
          <div id="general">
            <h2 className="text-2xl font-semibold text-gray-800 border-b pb-1 mb-3">
              1. General Provisions
            </h2>
            <p>
              <strong>1.1. Acceptance:</strong> These Terms constitute a legal agreement between you and Belle IT ("we," "us," or "our"). If you do not agree to these Terms, do not use our Services.
            </p>
            <p>
              <strong>1.2. Scope of Services:</strong> Belle IT provides specialized IT solutions, including managed hosting, software development, and cloud services, primarily to clients in the healthcare and related industries (Covered Entities).
            </p>
          </div>

          {/* Section 2: Account and Usage */}
          <div id="usage">
            <h2 className="text-2xl font-semibold text-gray-800 border-b pb-1 mb-3">
              2. Account and Service Usage
            </h2>
            <p>
              <strong>2.1. Client Responsibility:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use.
            </p>
            <p>
              <strong>2.2. Prohibited Uses:</strong> You may not use the Services for any illegal or unauthorized purpose, nor violate any laws in your jurisdiction (including but not limited to copyright laws).
            </p>
          </div>

          {/* Section 3: HIPAA Compliance and PHI Handling (CRITICAL SECTION) */}
          <div id="hipaa" className="bg-indigo-50 border-l-4 border-indigo-500 p-4 rounded-md">
            <h2 className="text-2xl font-extrabold text-indigo-700 border-b pb-2 mb-3">
              3. HIPAA Compliance and Protected Health Information (PHI)
            </h2>
            <p className="mb-2">
              <strong>3.1. Business Associate Agreement (BAA):</strong> To the extent Belle IT provides services that involve the creation, receiving, maintaining, or transmitting of Protected Health Information (PHI) on behalf of a Covered Entity, a separate, fully executed Business Associate Agreement ("BAA") is required and shall govern the handling of PHI. These Terms are subject to and superseded by the BAA regarding PHI.
            </p>
            <p className="mb-2">
              <strong>3.2. Belle IT's Role:</strong> Belle IT acts as a Business Associate (as defined by HIPAA) to our Covered Entity clients. We commit to maintaining the security and privacy of PHI in accordance with the HIPAA Security Rule, Privacy Rule, and Breach Notification Rule.
            </p>
            <p className="mb-2">
              <strong>3.3. Security Measures:</strong> We implement administrative, physical, and technical safeguards that reasonably and appropriately protect the confidentiality, integrity, and availability of the electronic PHI that we create, receive, maintain, or transmit on your behalf.
            </p>
            <p className="mb-2">
              <strong>3.4. Reporting:</strong> We will report to you any Security Incident, including any successful unauthorized access, use, disclosure, modification, or destruction of PHI of which we become aware, as required by the BAA.
            </p>
            <p>
              <strong>3.5. Client Responsibilities:</strong> You, as the Covered Entity, are responsible for obtaining all necessary patient consents and authorizations required under the Privacy Rule and for determining the minimum necessary standard for PHI access by your users.
            </p>
          </div>
          
          {/* Section 4: Data Security and Privacy */}
          <div id="security">
            <h2 className="text-2xl font-semibold text-gray-800 border-b pb-1 mb-3">
              4. Data Security and Privacy
            </h2>
            <p>
              <strong>4.1. Data Protection:</strong> We employ industry-standard security measures to protect all client data, including non-PHI data.
            </p>
            <p>
              <strong>4.2. Privacy Policy:</strong> Our collection and use of your personal information (non-PHI data) is governed by our separate Privacy Policy.
            </p>
          </div>

          {/* Section 5: Termination */}
          <div id="termination">
            <h2 className="text-2xl font-semibold text-gray-800 border-b pb-1 mb-3">
              5. Termination
            </h2>
            <p>
              We may terminate or suspend your access to all or part of the Services, without prior notice or liability, for any reason, including without limitation if you breach the Terms, or violate the BAA.
            </p>
          </div>

          {/* Section 6: Governing Law */}
          <div id="governing">
            <h2 className="text-2xl font-semibold text-gray-800 border-b pb-1 mb-3">
              6. Governing Law
            </h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of the State of [Your State], without regard to its conflict of law provisions.
            </p>
          </div>

          <footer className="pt-6 border-t mt-8">
            <p className="text-center text-sm text-gray-500">
              For questions about these Terms, please contact us at <a href="mailto:legal@belleit.net" className="text-indigo-600 hover:underline">legal@belleit.net</a>.
            </p>
          </footer>
        </section>
      </div>
    </div>
       </Container>
       <Footer />
     
     </AnimationRevealPage>
  );
};

export default TermsOfService;